import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import VenuesTranslateDraftView from "../../views/translate/VenuesTranslateDraftView";

import {withRouter} from 'cw-styleguide-react';
class VenuesTranslateDraftController extends Component {


  /**
   * componentDidMount
   */
  componentDidMount() {
    // Load the venue from the URL passed in.
    this.props.loadVenue(this.props.params.venue);
    this.props.loadAudit(this.props.params.venue);
    this.props.clearMessages();
  }

  /**
   * Render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <VenuesTranslateDraftView {...this.state} {...this.props}  />
      </Fragment>
    )
  }

}
 export default withRouter(withTranslation('local')(VenuesTranslateDraftController));
